import { OpenAPI, PaymentMethodVM } from "@propertelligent/client-api";
import { UserLoginData } from "../../common/charts/Enums";

/**
 * Raw-fetch bridge to the organization user's self-scoped payment-method list endpoint.
 *
 * The typed client method (PaymentService.getApiPaymentMethodOrganizationUserPaymentAccountMe) does not exist
 * until CI regenerates @propertelligent/client-api, so the My Settings > Payment Accounts screen reaches the new
 * /api/PaymentMethod/organization-user-payment-account/me endpoint through this helper, mirroring the platform
 * portal's fetchPlatformPaymentMethodList bridge (../../platform-portal/payment-accounts/platformPaymentAccountsApi.ts).
 *
 * TODO: replace the fetch below with the generated PaymentService method once client-api is regenerated.
 *
 * Returns the caller's own organization-user payment methods. A non-ok response, a network failure, or a parse
 * failure all throw -- this list is cap-limited (max 3), so the caller must be able to tell "load failed" apart
 * from "genuinely zero accounts" (the latter comes back as an ok response with an empty success array) to avoid
 * showing an "Add Your First Payment Account" prompt to someone who is actually already at the cap.
 */
export const fetchMyOrganizationUserPaymentMethods = async (): Promise<PaymentMethodVM[]> => {
  const token = sessionStorage.getItem(UserLoginData.token);
  const response = await fetch(
    `${OpenAPI.BASE}/api/PaymentMethod/organization-user-payment-account/me`,
    { method: "GET", headers: { Authorization: `Bearer ${token}` } }
  );
  if (!response.ok) {
    throw new Error(`Failed to load payment accounts (status ${response.status})`);
  }
  const data = await response.json();
  return data?.success ?? [];
};
